import { useEffect } from "react";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";

import {
  DISABLE_LOADING_SPINNER,
  ENABLE_LOADING_SPINNER,
} from "redux/reducers/header";
import { getEnabledGlobalLoadingSpinner } from "redux/selectors/header";

import Spinner from "components/Icons/Spinner";

export const GlobalLoadingSpinner = () => {
  const enabled = useSelector(getEnabledGlobalLoadingSpinner);
  const dispatch = useDispatch();

  useEffect(() => {
    // Setup a traditional browser event listener for areas of the application where it isn't feasible to use a redux action.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    document.addEventListener("toggleLoadingSpinner", (e: any) => {
      dispatch({
        reason: e?.detail?.reason,
        type: e?.detail?.enabled
          ? ENABLE_LOADING_SPINNER
          : DISABLE_LOADING_SPINNER,
      });
    });
  }, []);

  return (
    <div
      id="loading-spinner"
      className={classNames(
        "flex items-center inset-0 fixed justify-center opacity-100 z-50",
        {
          hidden: !enabled,
        }
      )}
    >
      <style jsx>{`
        #loading-spinner {
          background: rgba(0, 0, 0, 0.6);
        }
      `}</style>
      <Spinner />
    </div>
  );
};
